document.addEventListener("DOMContentLoaded", function() {
    const contenedor = document.getElementById('nieve-container');

    if (!contenedor) return; 

    const cantidadCopos = 25; 

    for (let i = 0; i < cantidadCopos; i++) {
        crearCopo();
    }

    function crearCopo() {
        const copo = document.createElement('div');
        copo.classList.add('copo');

        const tamaño = Math.random() * 8 + 4 + 'px'; 
        const posicionLeft = Math.random() * 100 + '%'; 
        const duracion = Math.random() * 3 + 4 + 's'; 
        const retraso = Math.random() * 5 + 's'; 

        copo.style.width = tamaño;
        copo.style.height = tamaño;
        copo.style.left = posicionLeft;
        copo.style.animationDuration = duracion;
        copo.style.animationDelay = retraso;

        contenedor.appendChild(copo);

        copo.addEventListener('animationiteration', () => {
            copo.style.left = Math.random() * 100 + '%';
        });
    }
});